import React from 'react';
import classNames from 'classnames';
import { observer } from 'mobx-react';

import { translate } from 'services/i18nService';
import ProfileStore from 'stores/ProfileStore';
import UserStore from 'stores/UserStore';
import { CHAT_AVATAR_URL } from 'containers/Chat/Api';

import DMCABadge from '../../../images/DMCABadge.png';

import styles from './DesktopBroadcastPaused.css';


function DesktopBroadcastPaused() {
  const { username: performerName } = ProfileStore.performerDetails;
  const { user: { sfw } } = UserStore;
  const avatarClasses = classNames({ [styles.blur]: sfw });

  return (
    <div className={styles.videoContainerPaused}>
      <div className={styles.DMCABadgeWrapper}>
        <img alt="DMCABadge" className={styles.DMCABadge} src={DMCABadge} />
      </div>
      <div className={styles.pausedContentWrap}>
        <div className={styles.imageWrap}>
          <img alt="performer" className={avatarClasses} src={CHAT_AVATAR_URL.replace('{username}', performerName)} />
        </div>
        <p>{translate('v2profile.need.moment', { 0: performerName })}</p>
        <p>{translate('v2profile.stream.resume.shortly')}</p>
      </div>
    </div>
  );
}

export default observer(DesktopBroadcastPaused);
